var RequestBrochure = (function () {

  var $requestBrochureSelector;
  var $formPanelSelector;
  var $successPanelSelector;
  var $errorMessageSelector;
  var $spinnerOverlaySelector;
  var configurationItem;
  var brochureTrackingObject;

  Utility.log('RequestBrochure.js loaded');

  function serviceHandler(serviceData) {
    var data = JSON.parse(serviceData);
    if (data.Status) {
      $formPanelSelector.addClass('hidden');
      $successPanelSelector.removeClass('hidden');
    } else {
      $errorMessageSelector.removeClass('hidden');
    }
    $spinnerOverlaySelector.addClass('hidden');
  }

  function sendData(form) {
    var action = $(form).attr('action');
    var data = {
      firstName: form.elements.firstName.value,
      lastName: form.elements.lastName.value,
      addressLineOne: form.elements.addressFirstLine.value,
      addressLineTwo: form.elements.addressSecondLine.value,
      city: form.elements.city.value,
      state: form.elements.state.value,
      zipcode: form.elements.zipCode.value,
      email: form.elements.email.value,
      model: form.dataset.model,
      terms: form.elements.terms.checked,
      brochureCode: form.dataset.brochurecd,
      interestId: form.dataset.interestid,
      configurationItem: configurationItem,
    };

    $.ajax({
      data: JSON.stringify(data),
      method: 'POST',
      async: true,
      contentType: 'application/json; charset=utf-8',
      error: function (data) {
        serviceHandler(data);
      },
      success: function (data) {
        serviceHandler(data);
        submitSuccessTrackingPageload();
        Acr.TrackingManager.restorePageLoadObject();
      },
      url: action,
    });
  }

  function submitHandler(event) {
    var success = Validation.validateForm(event);
    if (success) {
      $spinnerOverlaySelector.removeClass('hidden');
      sendData(event.target);
    }

    event.preventDefault();
    return false;
  }

  // submit Tracking pageload on brochure form success
  function submitSuccessTrackingPageload() {
    Acr.trackingObject.Page.page_name += ' success';
    if (Acr.TrackingManager) {
      Acr.TrackingManager.pageLoad();
    }
  }

  function selectEvent(event) {
    if (event.target.value !== '') {
      $(event.target).addClass('rab-form__select--selected');
    } else {
      $(event.target).removeClass('rab-form__select--selected');
    }
  }

  function attachEvents() {

    // Call events when new email input changes
    $requestBrochureSelector.find('input')
      .on('focus', Validation.onFocus)
      .on('blur', Validation.onBlur);

    // Call the Submit Form Method
    $requestBrochureSelector.submit(function (event) {
      $errorMessageSelector.addClass('hidden');
      submitHandler(event);
      event.preventDefault();
      event.stopImmediatePropagation();
    });

    $requestBrochureSelector.find('select').change(function (event) {
      selectEvent(event);
    });
  }

  function getQuerySelectors() {
    $requestBrochureSelector = $('.js-request-brochure');
    $formPanelSelector = $('.js-form-panel');
    $successPanelSelector = $('.js-success-panel');
    $errorMessageSelector = $('.js-server-message');
    $spinnerOverlaySelector = $('.js-spinner-overlay');
    brochureTrackingObject = $('[data-tracking-script]');
  }

  function getData() {
    configurationItem = $formPanelSelector.find('.js-configuration-item').text();
  }

  function init() {
    getQuerySelectors();
    if ($requestBrochureSelector.length > 0) {
      getData();
      attachEvents();
    }
  }

  return {
    init: init,
  };
}());
